var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as TypeGraphQL from 'type-graphql';
/**
 * System-wide summary statistics for OptionsGreeksHistory data
 */
let OptionsGreeksHistorySystemSummary = class OptionsGreeksHistorySystemSummary {
    totalAccounts;
    totalSnapshots;
    oldestSnapshot;
    newestSnapshot;
};
__decorate([
    TypeGraphQL.Field(_type => TypeGraphQL.Int, {
        nullable: false,
        description: 'Total number of unique accounts with Greeks history',
    }),
    __metadata("design:type", Number)
], OptionsGreeksHistorySystemSummary.prototype, "totalAccounts", void 0);
__decorate([
    TypeGraphQL.Field(_type => TypeGraphQL.Int, {
        nullable: false,
        description: 'Total number of Greeks snapshots across all accounts',
    }),
    __metadata("design:type", Number)
], OptionsGreeksHistorySystemSummary.prototype, "totalSnapshots", void 0);
__decorate([
    TypeGraphQL.Field(_type => Date, {
        nullable: true,
        description: 'Timestamp of the oldest Greeks snapshot in the system',
    }),
    __metadata("design:type", Object)
], OptionsGreeksHistorySystemSummary.prototype, "oldestSnapshot", void 0);
__decorate([
    TypeGraphQL.Field(_type => Date, {
        nullable: true,
        description: 'Timestamp of the newest Greeks snapshot in the system',
    }),
    __metadata("design:type", Object)
], OptionsGreeksHistorySystemSummary.prototype, "newestSnapshot", void 0);
OptionsGreeksHistorySystemSummary = __decorate([
    TypeGraphQL.ObjectType('OptionsGreeksHistorySystemSummary', {})
], OptionsGreeksHistorySystemSummary);
export { OptionsGreeksHistorySystemSummary };
//# sourceMappingURL=OptionsGreeksHistorySystemSummary.js.map